import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ApiDataStatus } from '@ui/shared/util-api';
import { BlueCityItemDetailsComponent } from './components/blue-city-item-details/blue-city-item-details.component';
import { BlueCityItem } from './definitions/blue-city-item';
import { Observable, switchMap, debounceTime } from 'rxjs';
import { BlueCityListDataService } from './services/blue-city-list-data';
import { FilterState } from '@ui/shared/domain-filter';
import { Result, ToResult } from '@team23/ts-result';
import { filterKeys } from './definitions/filter-keys';
import { ListItemComponent } from '@ui/shared/util-list';

const filterUpdateGracePeriod = 500;

@Component({
    selector: 'ui-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AppComponent {
    public title = 'blue-city';

    public itemContentComponentType: Type<ListItemComponent<BlueCityItem>> = BlueCityItemDetailsComponent;

    public listItems$: Observable<Result<Array<BlueCityItem>, ApiDataStatus>>;

    public areFiltersExpanded = false;

    public readonly fallbackListItems = ToResult.fromErrorKey(ApiDataStatus.Loading);

    constructor(
        private readonly _listDataService: BlueCityListDataService,
        activeFilterService: FilterState,
    ) {
        this.listItems$ = activeFilterService.activeFilters$
            .pipe(
                debounceTime(filterUpdateGracePeriod),
                switchMap(activeFilters =>
                    _listDataService.getListItems$({
                        titleContains:
                            activeFilters.get(filterKeys.textSearch)?.values[0]?.value as string | undefined ?? '',
                        categoryIds:
                            activeFilters.get(filterKeys.categories)?.values.map(value => value.value as number) ?? [],
                        sponsorIds:
                            activeFilters.get(filterKeys.sponsors)?.values.map(value => value.value as number) ?? [],
                    }),
                ),
            );
    }

    public reloadListData(): void {
        this._listDataService.reloadListItems();
    }
}
